import {StatusEventType} from '@constants/machine/status-event-signal/status-event-type.enum';

export class StatusEventDetails {
  code: string;
  type: StatusEventType;
  //used only to display the value fom the file in case of unsupported type
  initialType: string;
  description: string;
  metadata: Map<string, string>;
  localizations: Map<string, string>;


  constructor(code: string, type: StatusEventType,
              description: string, metadata: Map<string, string>,
              localizations: Map<string, string>) {

    this.code = code;
    this.type = type;
    this.initialType = '';
    this.description = description;
    this.metadata = metadata;
    this.localizations = localizations;
  }
}